
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.29 5.89001L11.29 15.89C10.9 16.28 10.27 16.28 9.88 15.89L7.05 13.06C6.66 12.67 6.66 12.04 7.05 11.65C7.44 11.26 8.07 11.26 8.46 11.65L10.58 13.77L19.87 4.48001C20.26 4.09001 20.89 4.09001 21.28 4.48001C21.68 4.87001 21.68 5.50001 21.29 5.89001ZM12 20C7.29 20 3.52 15.91 4.05 11.1C4.44 7.58001 7.17 4.69001 10.66 4.11001C12.47 3.81001 14.19 4.13001 15.65 4.89001C16.04 5.09001 16.51 5.02001 16.82 4.71001C17.3 4.23001 17.18 3.42001 16.58 3.11001C15.11 2.36001 13.45 1.95001 11.68 2.00001C6.54 2.16001 2.27 6.34001 2.01 11.47C1.72 17.24 6.3 22 12 22C13.2 22 14.34 21.79 15.41 21.4C16.09 21.15 16.28 20.27 15.76 19.75C15.49 19.48 15.08 19.38 14.72 19.52C13.87 19.83 12.95 20 12 20ZM19 15H17C16.45 15 16 15.45 16 16C16 16.55 16.45 17 17 17H19V19C19 19.55 19.45 20 20 20C20.55 20 21 19.55 21 19V17H23C23.55 17 24 16.55 24 16C24 15.45 23.55 15 23 15H21V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13V15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-add-task`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAddTask

    ```js
    <b-new-b-icon-add-task />
    ```
</docs>


